<template>
  <div class="notifications-list">
    <h4 class="flex align-center justify-between">{{ title }}<slot name="title" /></h4>
    <Divider type="horizontal" class="mt-2 mb-2" />
    <ul>
      <li v-for="notification in notifications" :key="notification.id" class="notifications-list__item">
        <a
          href="#"
          :class="clsx('notifications-list__link', { 'notifications-list__link--unread': !notification.read })"
          @click="() => $emit('open-notification', notification)"
        >
          <h5 class="notifications-list__subtitle flex align-center justify-between">{{ truncateString(notification.title, 320) }}
            <span class="notifications-list__date">{{ formatDateTime(notification.created_at, 'YYYY-MM-DD HH:mm') }}</span>
          </h5>
          {{ truncateHtmlText(markupToPlainText(notification.message), 380) }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import clsx from 'clsx';
import { dateTimeFormatter } from '@/shared/lib/date-time';
import { markupToPlainText } from '@/shared/lib/markup';
import { truncateString } from '@/shared/lib/string';
import { Divider } from '@/shared/ui/divider';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [ truncateString, dateTimeFormatter, markupToPlainText ],
  components: { Divider },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.notifications-list {
  color: #020617;

  &:nth-child(n+2) {
    margin-top: 16px;
  }

  &__item {
    &:nth-child(n+2) {
      margin-top: 8px;
    }
  }

  &__link {
    display: block;
    padding: 8px;
    font-size: 14px;
    font-weight: 400;

    &:hover {
      border: 1px solid #FB923C;
      border-radius: 4px;
      padding: 7px;
    }

    &--unread {
      background-color: #FB923C;
      border-radius: 4px;
    }
  }

  &__subtitle {
    font-size: 14px;
    font-weight: 500;
  }

  &__date {
    font-size: 12px;
    font-weight: 400;
    text-wrap: nowrap;
  }
}
</style>
